<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h1 mat-dialog-title>Add an Existing Chart</h1>
<div mat-dialog-content>
  <mat-form-field
    [formGroup]="fieldForm"
    id="searchDataPoints"
    style="width: 99%; height: 40px"
    appearance="fill"
  >
    <input
      matInput
      name="field"
      class="search-input"
      aria-label="Search Charts"
      placeholder="Search Charts"
      autocomplete="off"
      (keyup.enter)="search()"
      formControlName="field"
      style="margin-left: 10px"
    />
    <fa-icon
      [icon]="faSearch"
      matPrefix
      mat-button
      class="filterMenu"
    ></fa-icon>
  </mat-form-field>

  <mat-drawer-container class="search-container">
    <mat-drawer
      mode="side"
      position="start"
      closed
      class="side"
      [disableClose]="true"
    >
    </mat-drawer>

    <mat-drawer-content style="background-color: #fff !important">
      <div class="spinner-item">
        <mat-progress-spinner
          [mode]="'indeterminate'"
          [diameter]="75"
          [strokeWidth]="2"
          *ngIf="searching"
        >
        </mat-progress-spinner>
      </div>
      <div
        [hidden]="!error"
        class="initialSearch"
        [ngStyle]="{ color: error == errorText ? '#7a869a' : 'red' }"
      >
        {{ error
        }}<span
          [ngStyle]="{ display: error == errorText ? 'initial' : 'none' }"
          >{{ this.canvasType }}</span
        >
      </div>

      <cdk-virtual-scroll-viewport
        #scroller
        [itemSize]="50"
        [maxBufferPx]="600"
        [minBufferPx]="600"
        class="search-viewport"
        [ngStyle]="{ height: error ? '10px' : '400px' }"
      >
        <div *cdkVirtualFor="let field of dataFields; templateCacheSize: 5">
          <div (click)="addChartToReport(field.id)" class="searchMenu">
            <div class="left">
              <app-chart-icons [type]="field.chartType"></app-chart-icons>
            </div>
            <div class="right">
              <span class="title">{{ field.name }}</span>
              <span class="type">{{ field.chartType }} Chart</span>
            </div>
          </div>
        </div>
        <div class="spinner-item">
          <mat-progress-spinner
            [mode]="'indeterminate'"
            [diameter]="50"
            *ngIf="loading"
          >
          </mat-progress-spinner>
        </div>
      </cdk-virtual-scroll-viewport>
    </mat-drawer-content>
  </mat-drawer-container>
</div>

<div mat-dialog-actions align="end" style="display: block"></div>
